// Org regional preferences (timezone + country). Cached in localStorage so date
// formatting stays consistent across Audit Trail and Reports without a round-trip.
const TZ_KEY = 'kmt_timezone';
const COUNTRY_KEY = 'kmt_country';

export function getTimezone() {
  return localStorage.getItem(TZ_KEY) || '';
}
export function getCountry() {
  return localStorage.getItem(COUNTRY_KEY) || '';
}
export function setPrefsCache({ timezone, country }) {
  if (timezone !== undefined) localStorage.setItem(TZ_KEY, timezone || '');
  if (country !== undefined) localStorage.setItem(COUNTRY_KEY, country || '');
}

// Format a timestamp using the saved timezone (falls back to browser local).
export function formatDateTime(ts) {
  if (!ts) return '';
  const tz = getTimezone();
  try {
    return new Date(ts).toLocaleString(undefined, tz ? { timeZone: tz } : undefined);
  } catch (e) {
    try { return new Date(ts).toLocaleString(); } catch (_) { return String(ts); }
  }
}

// Common IANA timezones for the picker.
export const TIMEZONES = [
  'Asia/Kolkata', 'Asia/Dubai', 'Asia/Karachi', 'Asia/Dhaka', 'Asia/Singapore',
  'Asia/Shanghai', 'Asia/Tokyo', 'Asia/Riyadh', 'Europe/London', 'Europe/Paris',
  'Europe/Berlin', 'Europe/Moscow', 'America/New_York', 'America/Chicago',
  'America/Denver', 'America/Los_Angeles', 'America/Sao_Paulo', 'Australia/Sydney',
  'Africa/Johannesburg', 'UTC',
];

export const COUNTRIES = [
  'India', 'United Arab Emirates', 'Pakistan', 'Bangladesh', 'Singapore', 'China',
  'Japan', 'Saudi Arabia', 'United Kingdom', 'France', 'Germany', 'Russia',
  'United States', 'Brazil', 'Australia', 'South Africa', 'Canada', 'Other',
];
